import './price-and-shop.scss';
import {renderComponent} from 'modules/shared/utilities/ReactUtils';
import WhatsMyTireSize from 'modules/products/v2_0/tires/WhatsMyTireSize';
import YourSelectedSize from 'modules/products/v2_0/tires/YourSelectedSize';

renderComponent('.js-mount-whats-my-tire-size', WhatsMyTireSize);
renderComponent('.js-mount-your-size', YourSelectedSize);



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/tires/price-and-shop.ts